const AV_FETCHING_ASSIGNMENTS = 'AV_IS_FETCHING_ASSIGNMENTS'
const AV_FETCHING_ASSIGNMENTS_SUCCESS = 'AV_FETCHING_ASSIGNMENTS_SUCCESS'
const AV_FETCHING_ASSIGNMENTS_ERROR = 'AV_FETCHING_ASSIGNMENTS_ERROR'
const AV_OPEN_ASSIGNMENT = 'AV_OPEN_ASSIGNMENT'
const AV_CLOSE_ASSIGNMENT = 'AV_CLOSE_ASSIGNMENT'
const AV_SET_ACTIVE_USER = 'AV_SET_ACTIVE_USER'
const AV_FETCHING_USER_ASSIGNMENTS = 'AV_FETCHING_USER_ASSIGNMENTS'
const AV_FETCHING_USER_ASSIGNMENTS_SUCCESS = 'AV_FETCHING_USER_ASSIGNMENTS_SUCCESS'
const AV_FETCHING_USER_ASSIGNMENTS_ERROR = 'AV_FETCHING_USER_ASSIGNMENTS_ERROR'

/*
const AV_SAVING_TASK = 'AV_SAVING_TASK'
const AV_SAVING_TASK_SUCCESS = 'AV_SAVING_TASK_SUCCESS'
const AV_SAVING_TASK_ERROR = 'AV_SAVING_TASK_ERROR'
const AV_FETCHING_ITEMS = 'AV_FETCHING_ITEMS'
const AV_FETCHING_ITEMS_SUCCESS = 'AV_FETCHING_ITEMS_SUCCESS'
const AV_FETCHING_ITEMS_ERROR = 'AV_FETCHING_ITEMS_ERROR'
*/

// Fetch unique user assignment! Or create if it doesn't exist (outside of redux)
// When a user accesses for first time, a unique UserAssignment is created that has item refs
// and stores what the user does with the assignment when. The UserAssignment is not by default modified
// when the referenced Assignment is modified.

// Just start with the student viewing all of the items
// then modify so that they view certain assignments

export function fetchingAssignments () {
  return {
    type: AV_FETCHING_ASSIGNMENTS,
  }
}

export function fetchingAssignmentsSuccess(assignments) {
  return {
    type: AV_FETCHING_ASSIGNMENTS_SUCCESS,
    assignments,
  }
}

export function fetchingAssignmentsError(error) {
  return {
    type: AV_FETCHING_ASSIGNMENTS_ERROR,
    error,
  }
}

export function openAssignment(assignmentId) {
  return {
    type: AV_OPEN_ASSIGNMENT,
    activeAssignment: assignmentId,
  }
}

export function closeAssignment() {
  return {
    type: AV_CLOSE_ASSIGNMENT,
  }
}

export function setActiveUser(user) {
  return {
    type: AV_SET_ACTIVE_USER,
    user,
  }
}

export function fetchingUserAssignments() {
  return {
    type: AV_FETCHING_USER_ASSIGNMENTS,
  }
}

export function fetchingUserAssignmentsSuccess (userAssignments) {
  return {
    type: AV_FETCHING_USER_ASSIGNMENTS_SUCCESS,
    userAssignments,
  }
}

export function fetchingUserAssignmentsError (error) {
  return {
    type: AV_FETCHING_USER_ASSIGNMENTS_ERROR,
    error,
  }
}


const initialState = {
  assignments: null,
  activeAssignment: '',
  isFetchingAssignments: false,
  error: '',
  activeUser: null,
  isFetchingUserAssignments: false,
  activeUserAssignments: null,
}

export function assignmentsView (state = initialState, action) {
  switch (action.type) {
    case AV_FETCHING_ASSIGNMENTS :
      return {
        ...state,
        isFetchingAssignments: true,
      }
    case AV_FETCHING_ASSIGNMENTS_SUCCESS :
      return {
        ...state,
        isFetchingAssignments: false,
        assignments: action.assignments,
      }
    case AV_FETCHING_ASSIGNMENTS_ERROR :
      return {
        ...state,
        isFetchingAssignments: false,
        error: action.error,
      }
    case AV_OPEN_ASSIGNMENT :
      return {
        ...state,
        activeAssignment: action.activeAssignment,
      }
    case AV_CLOSE_ASSIGNMENT :
      return {
        ...state,
        activeAssignment: '',
      }
    case AV_SET_ACTIVE_USER :
      return {
        ...state,
        activeUser: action.user,
      }
    case AV_FETCHING_USER_ASSIGNMENTS :
      return {
        ...state,
        isFetchingUserAssignments: true,
      }
    case AV_FETCHING_USER_ASSIGNMENTS_SUCCESS :
      return {
        ...state,
        isFetchingUserAssignments: false,
        activeUserAssignments: action.userAssignments,
      }
    case AV_FETCHING_USER_ASSIGNMENTS_ERROR :
      return {
        ...state,
        isFetchingUserAssignments: false,
        error: action.error,
      }
    default :
      return state
  }
}



// WEBPACK FOOTER //
// ./src/redux/modules/assignmentsView.js